import React from "react";
import { FormikFormWrapperForJetpackConfig } from "../FormikForm/FormikFormWrapperForJetpackConfig";
import PrizesAndLoyaltyConfigurator from "./PrizesAndLoyaltyConfigurator";

const PrizesAndLoyaltyConfigWrapper = () => {
  return (
    <FormikFormWrapperForJetpackConfig
      ChildComponent={PrizesAndLoyaltyConfigurator}
      showSaveBar={false}
    />
  );
};

export default PrizesAndLoyaltyConfigWrapper;
